import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { useDelay } from 'publisher/hooks/useDelay'
import React from 'react'
import BlogLinkButton from 'src/publisher/entities/button-new/blog-link-button'
import CustomLoginButton from 'src/publisher/entities/button-new/custom-login-button'
import DownloadFileButton from 'src/publisher/entities/button-new/download-file-button'
import NextStepRedirectionButton from 'src/publisher/entities/button-new/next-step-redirection-button'
import OpenUrlButton from 'src/publisher/entities/button-new/open-url-button'
import SendFormButton from 'src/publisher/entities/button-new/send-form-button'
import ShowPopupButton from 'src/publisher/entities/button-new/show-popup-button'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'
import WebsiteLoginButton from './website-login-button'

export interface ButtonNewProps {
  entity: ButtonEntityInterface
}

const ButtonNew = ({ entity }: ButtonNewProps) => {
  const isVisible = useDelay(entity.delay)

  if (!isVisible) {
    return <div />
  }

  switch (entity.action) {
    case ButtonActionTypeEnum.NextStepRedirection:
      return <NextStepRedirectionButton entity={entity} />
    case ButtonActionTypeEnum.OpenUrl:
      return <OpenUrlButton entity={entity} />
    case ButtonActionTypeEnum.DownloadFile:
      return <DownloadFileButton entity={entity} />
    case ButtonActionTypeEnum.SendForm:
      return <SendFormButton entity={entity} />
    case ButtonActionTypeEnum.ShowPopup:
      return <ShowPopupButton entity={entity} />
    case ButtonActionTypeEnum.BlogLink:
      return <BlogLinkButton entity={entity} />
    case ButtonActionTypeEnum.Login:
    case ButtonActionTypeEnum.ResetPassword:
    case ButtonActionTypeEnum.ConfirmRegistration:
    case ButtonActionTypeEnum.ResetRequest:
      return <CustomLoginButton entity={entity} />
    case ButtonActionTypeEnum.WebsiteRegistration:
    case ButtonActionTypeEnum.WebsiteLogin:
    case ButtonActionTypeEnum.WebsiteResetPassword:
    case ButtonActionTypeEnum.WebsiteConfirmRegistration:
    case ButtonActionTypeEnum.WebsiteResetRequest:
      return <WebsiteLoginButton entity={entity} />
    default:
      return <div />
    // return <ContactUsButton entity={entity} />
    // rollbar.error('Unknown button action type', entity.action)
  }
}

export default ButtonNew
